import React, { useEffect, useState } from 'react';
import { PAGES, ROUTE_PATHS } from "../../InternalApiApp";
import { LogOut } from 'react-feather';
import Divider from '../Divider';
import PopupMenu from '../PopupMenu';
import PopupMenuItem from '../PopupMenuItem';
import ProfileImage from '../ProfileImage';
import "./ProfileMenu.scss";
import { useRemote } from '../../Utils/Utils';
import { useHistory } from 'react-router-dom';
import FlexWrapper from '../../layouts/FlexWrapper';

const ProfileMenu = ({ changeRoute, user, tenants, setSwitchingCompany, setShowSwitchCompanyModal }) => {
	const remote = useRemote();
	const history = useHistory();
	const [currentTenant, setCurrentTenant] = useState(null);
	const [otherTenants, setOtherTenants] = useState(null);

	useEffect(() => {
		const current = tenants.find(t => t.companyId === user.companyId)
		const others = tenants.filter(t => t.companyId !== user.companyId)
		setCurrentTenant(current);
		setOtherTenants(others)
	}, [tenants, user])


	const logout = () => {
		remote.get("/crm/logout").then((obo) => {
			//if we're impersonating, we'll have new access.
			if (obo && obo.data) {
				window.location.href = `/?${Math.random()}`;
			} else {
				history.push("/sign-in");
			}
		})
	}

	const switchUser = (user) => {
		setSwitchingCompany(true)
		remote.post(`/crm/tenants/${user.companyId}`).then(() => {
			window.location.href = `/?${Math.random()}`;
		})
	}


	return (
		<>
			<PopupMenu padding width="300px">
				<div className="profile-menu-header-container">
					<ProfileImage user={user} src={user && "data:image/jpeg;base64," + user.photo} />
					<div className="profile-menu-details">
						<div className="profile-header">{user && user.name}</div>
					</div>
				</div>
				<Divider />
				<PopupMenuItem label="Profile" onClick={() => changeRoute(ROUTE_PATHS[PAGES.SETTINGS] + "/profile")} />
				<Divider />
				{currentTenant && <>
					<div className="section-header">Account</div>
					<div className='current-account-company'>
						<p style={{ display: 'flex', alignItems: 'center' }} className='gap-xs'>
							{currentTenant.companyName}
							{currentTenant.isBookmarked && <i className='font-size-body-s material-icons colour-text-primary'>bookmark</i>}
						</p>
						<p className='current-account-role'>
							{currentTenant?.roleDTO?.displayName}
						</p>
					</div>
				</>}
				{otherTenants && otherTenants.length > 0
					? <>
						<Divider />
						<FlexWrapper justify="space-between" >
							<div className="section-header">Switch Account</div>
							<p style={{ color: "#0E8EFD", fontSize: "0.74rem", marginBottom: "0.5rem", cursor: "pointer" }} onClick={() => setShowSwitchCompanyModal(true)}>See All ({otherTenants.length})</p>
						</FlexWrapper>
						{otherTenants && otherTenants.map((acc, idx) => {
							return idx > 4 ? "" : <div onClick={() => switchUser(acc)} key={acc.companyId} className="profile-menu-option">
								<PopupMenuItem
									label={acc.isBookmarked ? <div style={{ display: 'flex', alignItems: 'center' }} className='gap-xs'>{acc.companyName}<i className='font-size-body-s material-icons colour-text-primary'>bookmark</i></div> : acc.companyName}
									subLabel={acc?.roleDTO?.displayName}
								/>
							</div>
						})}
					</>
					: ""
				}
				<Divider />
				<PopupMenuItem label="Logout" icon={<LogOut />} onClick={logout} />
			</PopupMenu>
		</>
	)
}

export default ProfileMenu;